import { render, staticRenderFns } from "./ListUser.vue?vue&type=template&id=72241861&scoped=true"
import script from "./ListUser.vue?vue&type=script&lang=js"
export * from "./ListUser.vue?vue&type=script&lang=js"
import style0 from "./ListUser.vue?vue&type=style&index=0&id=72241861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72241861",
  null
  
)

export default component.exports